import React, { Component } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

const breakpoints = createBreakpoints({});

function pxToRem(value) {
  return `${value / 16}rem`;
}

const styles = () => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: "10px",
    "flex-direction": "column"
  },
  header: {
    fontWeight: "bold",
    paddingBottom: 16
  },
  video: {
    [breakpoints.down("md")]: {
      fontSize: pxToRem(16)
    },
    [breakpoints.down("sm")]: {
      fontSize: pxToRem(12)
    },
    [breakpoints.down("xs")]: {
      fontSize: pxToRem(8)
    },
    width: "40em",
    height: "22.5em"
  }
});

class VimeoPlayer extends Component {
  render() {
    const { classes, videoKey } = this.props;
    const video = this.props.videos[videoKey];
    if (video && video.id) {
      const src = `https://player.vimeo.com/video/${video.id}`;
      return (
        <div className={classes.container}>
          {videoKey === "live" ? (
            <h2 style={{ color: "#74AE02" }}>Live Event</h2>
          ) : null}

          <span className={classes.header}>
            {this.props.videos[this.props.videoKey].title}
          </span>
          <div className={classes.video}>
            <iframe
              title="Video1"
              src={src}
              width="100%"
              height="100%"
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const data = state.videos.reduce((obj, item) => {
    obj[item.key] = item;
    return obj;
  }, {});
  return {
    videos: {
      ...data,
      live: state.video
    }
  };
};

export default connect(mapStateToProps)(withStyles(styles)(VimeoPlayer));



// WEBPACK FOOTER //
// ./src/components/common/VimeoPlayer.js